// ─── Sound Toggle ───
function toggleSound() {
  const video = document.getElementById('trailer-video');
  const iconMuted = document.getElementById('icon-muted');
  const iconSound = document.getElementById('icon-sound');
  if (video.muted) {
    video.muted = false;
    iconMuted.style.display = 'none';
    iconSound.style.display = 'block';
  } else {
    video.muted = true;
    iconMuted.style.display = 'block';
    iconSound.style.display = 'none';
  }
}

// ─── Know Tabs ───
function switchTab(btn, panelId) {
  const section = btn.closest('.section-know');
  section.querySelectorAll('.know-tab').forEach(t => t.classList.remove('active'));
  section.querySelectorAll('.know-panel').forEach(p => p.classList.remove('active'));
  btn.classList.add('active');
  document.getElementById(panelId).classList.add('active');
}

// ─── Cart State ───
let cart = [];

function openCart() {
  document.getElementById('cartDrawer').classList.add('open');
  document.getElementById('cartOverlay').classList.add('open');
  renderCart();
}

function closeCart() {
  document.getElementById('cartDrawer').classList.remove('open');
  document.getElementById('cartOverlay').classList.remove('open');
}

function addToCart(btn, name, priceStr, priceNum) {
  const existing = cart.find(i => i.name === name);
  if (existing) {
    existing.qty += 1;
  } else {
    cart.push({ name, priceStr, priceNum, qty: 1 });
  }
  updateBadge();
  showToast('Added to cart: ' + name);
  renderCart();
}

function removeFromCart(index) {
  cart.splice(index, 1);
  updateBadge();
  renderCart();
}

function changeQty(index, delta) {
  cart[index].qty += delta;
  if (cart[index].qty <= 0) cart.splice(index, 1);
  updateBadge();
  renderCart();
}

function updateBadge() {
  const total = cart.reduce((s, i) => s + i.qty, 0);
  const badge = document.getElementById('cartBadge');
  badge.textContent = total;
  badge.classList.toggle('visible', total > 0);
}

function renderCart() {
  const container = document.getElementById('cartItems');
  const footer = document.getElementById('cartFooter');
  const empty = document.getElementById('cartEmpty');

  if (cart.length === 0) {
    if (empty) empty.style.display = 'block';
    footer.style.display = 'none';
    container.innerHTML = '';
    updateFormSummary();
    return;
  }

  if (empty) empty.style.display = 'none';
  footer.style.display = 'block';

  let html = '';
  cart.forEach((item, i) => {
    const lineTotal = item.priceNum * item.qty;
    const lineTotalStr = '\u20ac' + lineTotal.toLocaleString('de-DE', {minimumFractionDigits:2, maximumFractionDigits:2});
    html += `
      <div class="cart-item">
        <div class="cart-item-info">
          <div class="cart-item-name">${item.name}</div>
          <div class="cart-item-sub">Bahrain GP 2026</div>
          <div class="cart-item-price">${lineTotalStr}</div>
          <div class="cart-item-qty">
            <button class="qty-btn" onclick="changeQty(${i},-1)">−</button>
            <span class="qty-val">${item.qty}</span>
            <button class="qty-btn" onclick="changeQty(${i},1)">+</button>
          </div>
        </div>
        <button class="cart-item-remove" onclick="removeFromCart(${i})" title="Remove">&#x2715;</button>
      </div>`;
  });
  container.innerHTML = html;

  const total = cart.reduce((s, i) => s + i.priceNum * i.qty, 0);
  document.getElementById('cartTotal').textContent = '€' + total.toLocaleString('de-DE', {minimumFractionDigits:2, maximumFractionDigits:2});
  // Also update form summary live
  updateFormSummary();
}

function updateFormSummary() {
  const summaryEl = document.getElementById('formCartSummary');
  const selectorEl = document.getElementById('formPackageSelector');
  const selField = document.getElementById('bSelection');
  if (!summaryEl) return;
  if (cart.length === 0) {
    summaryEl.innerHTML = '';
    if (selectorEl) selectorEl.style.display = 'block';
    if (selField) selField.value = '';
    return;
  }
  // Hide manual selector, show cart summary
  if (selectorEl) selectorEl.style.display = 'none';
  const total = cart.reduce((s, i) => s + i.priceNum * i.qty, 0);
  const totalStr = '\u20ac' + total.toLocaleString('de-DE', {minimumFractionDigits:2, maximumFractionDigits:2});
  let lines = cart.map((item, idx) => {
    const lineTotal = item.priceNum * item.qty;
    const lineTotalStr = '\u20ac' + lineTotal.toLocaleString('de-DE', {minimumFractionDigits:2, maximumFractionDigits:2});
    return `<div class="form-cart-line" style="display:flex;justify-content:space-between;align-items:center;padding:8px 0;border-bottom:1px solid #eee;">
      <span style="flex:1;font-weight:600;font-size:14px;">${item.name}</span>
      <span style="margin:0 12px;color:#888;font-size:13px;">x${item.qty}</span>
      <span style="font-weight:700;font-size:14px;min-width:80px;text-align:right;">${lineTotalStr}</span>
      <button onclick="removeFromCart(${idx});updateFormSummary();" style="margin-left:12px;background:none;border:none;color:#d32f2f;cursor:pointer;font-size:18px;line-height:1;" title="Remove">&times;</button>
    </div>`;
  }).join('');
  summaryEl.innerHTML = `<div style="background:#f9f9f9;border:1px solid #e0e0e0;border-radius:8px;padding:14px 16px;margin-bottom:4px;"><div style="font-weight:700;font-size:15px;margin-bottom:10px;letter-spacing:0.5px;">Your Selection</div>${lines}<div style="display:flex;justify-content:space-between;font-weight:700;font-size:15px;padding-top:10px;margin-top:4px;border-top:2px solid #e0e0e0;"><span>Total</span><span>${totalStr}</span></div></div>`;
  if (selField) selField.value = cart.map(i => i.name + ' x' + i.qty + ' (' + i.priceStr + ')').join(' | ');
}

function updateFormFromCheckboxes() {
  const checked = Array.from(document.querySelectorAll('input[name="pkg"]:checked'));
  const selField = document.getElementById('bSelection');
  if (selField) selField.value = checked.map(c => c.value).join(' | ');
}

function toggleFaq(btn) {
  const item = btn.closest('.faq-item');
  const isOpen = item.classList.contains('open');
  // Close all
  document.querySelectorAll('.faq-item.open').forEach(el => el.classList.remove('open'));
  // Open clicked if it was closed
  if (!isOpen) item.classList.add('open');
}

function showToast(msg) {
  const t = document.getElementById('toast');
  t.textContent = msg;
  t.classList.add('show');
  setTimeout(() => t.classList.remove('show'), 2200);
}

// ─── Proceed to Checkout: scroll to form and show cart summary ───
function proceedToCheckout() {
  if (cart.length === 0) return;
  closeCart();
  updateFormSummary();
  // Scroll to form
  const formSection = document.querySelector('.section-form');
  if (formSection) formSection.scrollIntoView({behavior: 'smooth', block: 'start'});
}

// ─── Submit Enquiry via Web3Forms ───
function submitEnquiry() {
  const firstName = (document.getElementById('bFirstName') || {}).value || '';
  const lastName = (document.getElementById('bLastName') || {}).value || '';
  const email = (document.getElementById('bEmail') || {}).value || '';
  const phoneRaw = (document.getElementById('bPhone') || {}).value || '';
  const phone = itiPhone ? itiPhone.getNumber() : phoneRaw;
  const comments = (document.getElementById('bComments') || {}).value || '';
  const privacy = document.getElementById('privacy');
  const selection = (document.getElementById('bSelection') || {}).value || 'No items selected';

  if (!firstName.trim()) { alert('Please enter your first name.'); return; }
  if (!lastName.trim()) { alert('Please enter your last name.'); return; }
  if (!email.trim() || !email.includes('@')) { alert('Please enter a valid email address.'); return; }
  if (!privacy || !privacy.checked) {
    alert('Please agree to our privacy policy before submitting.');
    return;
  }

  const btn = document.querySelector('.btn-submit');
  btn.disabled = true;
  btn.textContent = 'SENDING...';

  const formData = new FormData();
  formData.append('name', firstName + ' ' + lastName);
  formData.append('email', email);
  const dialCode = itiPhone ? '+' + itiPhone.getSelectedCountryData().dialCode : '';
  const countryName = itiPhone ? itiPhone.getSelectedCountryData().name : '';
  formData.append('phone', phone);
  formData.append('country_dial_code', dialCode + (countryName ? ' (' + countryName + ')' : ''));
  formData.append('selection', selection);
  formData.append('comments', comments);
  formData.append('access_key', 'ff50f157-3ddb-4dad-b653-cdad130ae7de');
  formData.append('subject', 'Bahrain GP 2026 Enquiry – ' + firstName + ' ' + lastName);
  formData.append('from_name', 'GP Travel Website');

  fetch('https://api.web3forms.com/submit', {
    method: 'POST',
    body: formData,
    headers: { 'Accept': 'application/json' }
  })
  .then(response => {
    if (response.ok) {
      btn.textContent = 'SENT ✓';
      btn.style.background = '#2e7d32';
      showToast('Thank you! We will contact you shortly.');
      // Reset form
      document.getElementById('bFirstName').value = '';
      document.getElementById('bLastName').value = '';
      document.getElementById('bEmail').value = '';
      if (document.getElementById('bComments')) document.getElementById('bComments').value = '';
      if (privacy) privacy.checked = false;
    } else {
      btn.disabled = false;
      btn.textContent = 'SUBMIT';
      alert('Something went wrong. Please email us directly at info@gp-travel.com');
    }
  })
  .catch(() => {
    btn.disabled = false;
    btn.textContent = 'SUBMIT';
    alert('Connection error. Please email us directly at info@gp-travel.com');
  });
}

// ─── Phone field with country flag ───
let itiPhone = null;
function initPhoneField() {
  const phoneInput = document.getElementById('bPhone');
  if (phoneInput && window.intlTelInput) {
    itiPhone = window.intlTelInput(phoneInput, {
      initialCountry: 'auto',
      geoIpLookup: function(callback) {
        fetch('https://ipapi.co/json/')
          .then(r => r.json())
          .then(data => callback(data.country_code))
          .catch(() => callback('nl'));
      },
      loadUtilsOnInit: 'https://cdn.jsdelivr.net/npm/intl-tel-input@23/build/js/utils.js',
      separateDialCode: true,
    });
  }
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initPhoneField);
} else {
  initPhoneField();
}
